import { TOKEN_NAME, REFRESH_TOKEN_NAME, COOKIE_KEY_LOCALE } from '../config/consts';
import { setCookie, getCookie } from './cookie.service';

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 *
 **/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_NAME);
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_NAME, accessToken);
    },

    removeToken() {
        localStorage.removeItem(TOKEN_NAME);
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_NAME);
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_NAME, refreshToken);
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_NAME);
    }
};

const LocaleService = {
    locales: {
        kz: 'kk-KK',
        ru: 'ru-RU'
    },
    setLocale(locale) {
        setCookie(COOKIE_KEY_LOCALE, this.locales[locale], 30);
    },
    getLocale() {
        let locale = getCookie(COOKIE_KEY_LOCALE);
        if (locale) {
            for (let i in this.locales) {
                if (locale === this.locales[i]) {
                    return i;
                }
            }
        }
        return null;
    }
};

export { TokenService, LocaleService };
